/* Banda — el veredicto de un proceso: la cifra de afinidad y su etiqueta.
 *
 * REGLA QUE NO SE ROMPE: el color nunca informa solo. La etiqueta de texto («Compite», «Mejor no»)
 * va SIEMPRE, no como título ni como ayuda emergente. Alguien que no distingue el verde del rojo
 * tiene que poder decidir igual, y quien imprime la pantalla también.
 *
 * Ni la cifra ni la banda se calculan aquí: las manda el servidor (`_afinidad`, `_banda`).
 */
import type { BandaVeredicto } from '../api/tipos'
import { ETIQUETA_BANDA } from '../api/formato'
import './Banda.css'

/**
 * La píldora del veredicto. Mide lo que dice y nada más.
 *
 * `afinidad` es OPCIONAL y en la cabecera del panel NO se pasa: ahí la cifra va suelta al otro
 * extremo de la fila, a 32 px. Meterla dentro obligaba a estirar la píldora a los 370 px de la
 * columna para que el número se leyera, y una etiqueta que ocupa la fila entera deja de leerse
 * como etiqueta. Dentro sigue teniendo sentido donde el espacio es una línea de tabla.
 */
export function Banda({ banda, afinidad }: {
  banda: BandaVeredicto
  afinidad?: number | undefined
}) {
  return (
    <span className={`banda banda-${banda}`}>
      {afinidad !== undefined && <b className="cifra">{afinidad}</b>}
      <span>{ETIQUETA_BANDA[banda]}</span>
    </span>
  )
}

/** Barra de magnitud: el ancho ES la afinidad. Decorativa — la cifra ya está al lado, así que se
 *  oculta a los lectores de pantalla en vez de hacerles leer un porcentaje repetido. */
export function BarraAfinidad({ afinidad, banda }: { afinidad: number; banda: BandaVeredicto }) {
  return (
    <span className={`barra barra-${banda}`} aria-hidden="true">
      <i style={{ width: `${Math.max(0, Math.min(100, afinidad))}%` }} />
    </span>
  )
}
